// extracted by css-extract-rspack-plugin
export default {"groupSegmentBorder":"lqQk33V3JwI7WEUc","subgroupSegmentBorder":"qD_9w0VncDsjw7vS","personalLink":"a_k0dvfimwsotEDd","cat":"K7ur3SG3iE4kt8rY"};